const formatDeliveryDate = (locale, dateString = '')=>{
    const date = new Date(dateString);
    if (isNaN(date.getTime())) {
        return '';
    }
    return new Intl.DateTimeFormat(locale, {
        weekday: 'short',
        day: 'numeric',
        month: 'short'
    }).format(date).replace(/[.,]/g, '');
};

export { formatDeliveryDate };
//# sourceMappingURL=formatDeliveryDate.js.map
